import React from "react";
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Modal, Icon, Typography, Tooltip } from 'antd'


// Components
import Message from "../../components/Messages";
import typo, { MESSAGE } from "../../constants/dictionaries";
import Api_dms from "../../api/api.dms";
const { Text } = Typography;
class DownloadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
    }

    downFile = (data) => {
        if (data === undefined || data === []) {
            Message.warning(MESSAGE.CSCORE_KHONG_CO_GIAY_PHEP)
        } else {
            new Api_dms().DownloadFile({
                token: this.props.user.access_token,
                data: { oid: data.idFile, filename: data.tenTaiLieu }
            })
        }
    }
    render() {
        const { user, isOpen, handleCancel, selectdFile } = this.props
        return (
            <Modal
                visible={isOpen}
                title="Danh sách tài liệu đính kèm"
                footer={false}
                onCancel={handleCancel}
                centered={true}
            >
                {selectdFile.map((item, index) => {
                    return <div style={{ display: "flex", justifyContent: "space-between" }} onClick={() => this.downFile(item)}>
                        <p className="row-name cursor_grab">{index + 1 + ". " + item.tenTaiLieu}</p>
                        <Tooltip placement="top" title="Tải xuống">
                            <div className="row-name cursor_grab"><Icon type="download" /></div>
                        </Tooltip>
                    </div>
                })}
            </Modal>
        )
    };
}


DownloadFile.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleCancel: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
    user: store.oidc.user
});

export default connect(mapStateToProps)(DownloadFile);

